import { IDocuments } from '../../types';
import { BRPCalculation } from './BRP-calculation';
import { addTime } from './helpers/addTime';
import { isStudentVisaCalculationAllowed } from './helpers/isStudentVisaCalculationAllowed';

export const getT4VisaTime = (documents: IDocuments | undefined): number => {
  let totalTime = 0;
  if (!documents || !documents.studentVisas) {
    return totalTime; // skip calculation
  }

  Object.values(documents.studentVisas).forEach(visa => {
    if (!isStudentVisaCalculationAllowed(visa)) {
      return; // skip calculation
    }

    const BRPCheckResponse = BRPCalculation(visa.biometric, visa.visa, visa.shortenedDate);

    if (BRPCheckResponse) {
      totalTime = addTime(totalTime, BRPCheckResponse);
      return;
    }

    Object.values(visa.visa ?? {}).forEach((studentVisa: any) => {
      if (studentVisa.startDate) {
        if (visa.isVisaShortened) {
          totalTime = addTime(totalTime, {
            startDate: studentVisa.startDate,
            endDate: visa.shortenedDate!,
          });
        } else if (studentVisa.endDate) {
          totalTime = addTime(totalTime, {
            startDate: studentVisa.startDate,
            endDate: studentVisa.endDate,
          });
        }
      }
    });
  });

  return totalTime;
};
